<template>
  <div
    :style="`max-height: min-content; font-size: ${this.pageSettings.fontSize}`"
    class="q-ma-sm"
  >
    <div class="text-left" id="recibo">
      <q-avatar rounded size="70px">
        <img :src="loja?.LOGO ? loja.LOGO : defaultLogo" />
      </q-avatar>
      <br />
      <br />
      <strong>
        {{ loja?.NOME }}<br />
        {{ loja?.WHATSAPP }}<br />
        {{ loja?.CPF_CNPJ }}
      </strong>
      <br />
      <br />
      <strong>RECIBO DE MOVIMENTO DE CAIXA </strong>
      <br />

      DATA MOVIMENTO: {{ dateFormat(recibo[0]?.DATA) }}
      <br />
      <br />
      <div>
        <strong>TOTALIZADORES</strong>
        <ul>
          <li>
            VENDAS DINHEIRO: <strong> R${{ recibo?.DINHEIRO || 0 }} </strong>
          </li>

          <li>
            VENDAS PIX: <strong> R${{ recibo?.sangriasPix || 0 }} </strong>
          </li>

          <li>
            VENDAS CARTÃO DE CRÉDITO:
            <strong> R${{ recibo?.CARTAO_CREDITO || 0 }} </strong>
          </li>
          <li>
            VENDAS CARTÃO DE DÉBITO:
            <strong> R${{ recibo?.CARTAO_DEBITO || 0 }} </strong>
          </li>
          <li>
            SANGRIAS PIX: <strong> R${{ recibo?.PIX || 0 }} </strong>
          </li>
          <li>
            SANGRIAS DINHEIRO:
            <strong> R${{ recibo?.sangriasDinheiro || 0 }} </strong>
          </li>
        </ul>

        TOTAL ENTRADAS: R$ {{ recibo.totalEntradas || 0 }} <br />
        TOTAL SAÍDAS: R$ {{ recibo.totalSaidas || 0 }}
        <q-separator />
      </div>

      <strong
        >SALDO TOTAL MOVIMENTO: R${{
          parseFloat(recibo?.TOTAL_DIA, 0).toFixed(2)
        }}</strong
      >
      <br />
      <div class="text-center">
        <p>{{ recibo.DATA }}{{ recibo.ID }}<br /></p>
        MINI PDV - CONTROLE DE VENDAS E ESTOQUE
      </div>
    </div>
  </div>
</template>
<script>
import formaters from "../../../helpers/formaters";
export default {
  name: "ReciboPage",
  data() {
    return {
      recibo: {},
      logoPath: "",
      loja: JSON.parse(localStorage.getItem("loja")),
      columns: [
        {
          name: "tipo",
          label: "Tipo Pagamento",
          field: "TIPO_PAGAMENTO",
          align: "left",
          sortable: true,
        },
        {
          name: "total",
          label: "Total R$",
          field: "TOTAL",
          align: "left",
          sortable: true,
        },
      ],
      pagination: {
        rowsPerPage: 0,
      },
      pageSettings: {
        fontSize: "14px",
      },
      tipo: "",
    };
  },
  async created() {
    this.recibo = await JSON.parse(this.$route.query.data);

    this.tipo = this.$route.query.tipo;
    this.setFontSize();
    this.printPage();
  },
  async mounted() {},
  computed: {
    defaultLogo() {
      return require("../../../../public/icons/icon-512x512.png");
    },
  },
  methods: {
    printPage() {
      window.print();
    },
    dateFormat(date) {
      return formaters.receiptDate(date);
    },
    setFontSize() {
      switch (this.loja.TAMANHO_IMPRESSAO) {
        case "58mm":
          this.pageSettings.fontSize = "12px";
          break;

        case "80mm":
          this.pageSettings.fontSize = "16px";
          break;

        default:
          this.pageSettings.fontSize = "14px";
          break;
      }
    },
  },
};
</script>
